module.exports = __webpack_public_path__ + "assets/howlerjs.8ac4d0cd.svg";